import { motion } from 'framer-motion';
import { CHAPTERS } from '../data/site';

export default function About() {
  return (
    <section id="sobre" className="relative py-24 sm:py-32" data-testid="sobre-nos-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Sobre nós
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Nosso manifesto
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Capítulos de uma paixão obcecada pelo hambúrguer perfeito.
        </motion.p>

        <div className="mt-14 grid gap-12 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="relative overflow-hidden rounded-3xl border border-white/10 lg:sticky lg:top-28">
              <img
                src="/fotos/08.jpg"
                alt="Mural do trailer da Riths Burger em Nova Friburgo"
                className="aspect-[3/4] w-full object-cover"
                data-testid="sobre-nos-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0F]/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
                <div>
                  <p className="font-display text-3xl uppercase text-white">Desde o primeiro burger</p>
                  <p className="font-mono-alt mt-1 text-xs uppercase tracking-[0.25em] text-[#FFB800]">
                    Centro · Nova Friburgo · RJ
                  </p>
                </div>
                <span
                  className="mb-1 inline-flex shrink-0 items-center gap-1 rounded-full border border-[#FFB800]/40 bg-[#0D0D0F]/70 px-3 py-1 font-mono-alt text-[11px] uppercase tracking-wider text-[#FFB800] backdrop-blur-md"
                  data-testid="sobre-nos-rating-chip"
                >
                  4,5 no Google
                </span>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.number}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, delay: i * 0.12 }}
                className="flex gap-6 border-t border-white/10 py-10 first:border-t-0 first:pt-0 sm:gap-10"
                data-testid={`sobre-nos-chapter-${c.number}`}
              >
                <span className="text-outline font-display text-6xl leading-none sm:text-8xl">
                  {c.number}
                </span>
                <div>
                  <h3 className="font-display text-3xl uppercase text-white sm:text-4xl">
                    {c.title}
                  </h3>
                  <p className="mt-3 max-w-lg text-base leading-relaxed text-zinc-400">{c.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
